import { createRoot, hydrateRoot } from 'react-dom/client';
import App from './App';
import { loadPageComponent } from './lib/route-loader';
import { resolveRoute } from './lib/routes';
import './index.css';
import './styles/design-tokens.css';
import './styles/globals.css';
import './styles/select.css';

const root = document.getElementById('root')!;

async function startApp() {
  const currentPath = window.location.pathname + window.location.search + window.location.hash;
  try {
    const initialPage = await loadPageComponent(resolveRoute(currentPath).type);
    document.getElementById('app-load-recovery')?.remove();
    const app = <App initialPath={currentPath} initialPage={initialPage} />;
    if (root.hasChildNodes()) hydrateRoot(root, app);
    else createRoot(root).render(app);
  } catch {
    // Keep the static article and ordinary navigation available after an interrupted download.
    if (document.getElementById('app-load-recovery')) return;
    const notice = document.createElement('aside');
    notice.id = 'app-load-recovery';
    notice.setAttribute('role', 'status');
    notice.className = 'max-w-3xl mx-auto p-4';
    const message = document.createElement('p');
    message.textContent = 'Interactive features could not load. You can still read this page and follow its links.';
    const retry = document.createElement('button');
    retry.textContent = 'Retry interactive features';
    retry.className = 'text-green-700 underline';
    retry.addEventListener('click', () => { notice.remove(); void startApp(); });
    notice.append(message, retry);
    root.before(notice);
  }
}

void startApp();
